import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SubscriptionAppService } from 'src/app/services/subscription-app.service';
@Component({
  selector: 'app-cus-solutions',
  template: `
    <div class="cs-page">
      <div class="pagehead">
        <h1>My solutions</h1>
        <p>Configure and run your subscribed solutions, and manage who can access them.</p>
      </div>

      <div class="tabs">
        <span
          class="tab"
          [class.active]="activeTab === 'current'"
          (click)="activeTab = 'current'"
          >Current <span class="cnt">{{ availableSubscriptions?.length || 0 }}</span></span
        >
        <span
          class="tab"
          [class.active]="activeTab === 'past'"
          (click)="activeTab = 'past'"
          >Past <span class="cnt">{{ pastSubscription?.length || 0 }}</span></span
        >
      </div>

      <!-- Current subscriptions -->
      <div class="sub-list" *ngIf="activeTab === 'current'">
        <div class="empty" *ngIf="!availableSubscriptions?.length">
          No active subscriptions yet. Browse the marketplace to subscribe to a solution.
        </div>

        <app-subscription-card
          *ngFor="let sub of availableSubscriptions"
          [sub]="sub"
          [expandable]="true"
          [startExpanded]="true"
        ></app-subscription-card>
      </div>

      <!-- Past subscriptions -->
      <div class="sub-list" *ngIf="activeTab === 'past'">
        <div class="empty" *ngIf="!pastSubscription?.length">No past subscriptions.</div>
        <div class="past-card" *ngFor="let sub of pastSubscription">
          <div class="past-ico">
            <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor"
                 stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="4" width="18" height="13" rx="2" /><path d="M8 21h8M12 17v4" />
            </svg>
          </div>
          <div class="past-mid">
            <div class="past-nm">{{ sub['solution_name'] | textpretty | titlecase }}</div>
            <div class="past-meta">
              Expired {{ sub['expires_on_dtm'] | date : 'dd MMM yyyy' }}
            </div>
          </div>
          <span class="exp-badge">Expired</span>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./cus-solutions.component.scss'],
})
export class CusSolutionsComponent implements OnInit {
  componentCheck: boolean = false;
  availableSubscriptions: any;
  pastSubscription: any;
  activeTab: 'current' | 'past' = 'current';

  constructor(
    private route: ActivatedRoute,
    private subscriptionServices: SubscriptionAppService
  ) {}

  ngOnInit(): void {
    if (this.route.component === CusSolutionsComponent) {
      this.componentCheck = false;
    } else {
      this.componentCheck = true;
    }
    this.fetchSubscription();
  }

  fetchSubscription() {
    this.subscriptionServices.getSubscribedSolutions().subscribe({
      next: (response: any) => {
        this.availableSubscriptions = response['msg'];
        this.fetchPastSubscription();
      },
    });
  }

  fetchPastSubscription() {
    this.subscriptionServices.getUnSubscribedSolutions().subscribe({
      next: (response: any) => {
        this.pastSubscription = response['msg'];
        this.pastSubscription = this.pastSubscription.filter(
          (item2: any) =>
            !this.availableSubscriptions.some(
              (item1: any) => item1.solution_id === item2.solution_id
            )
        );
      },
    });
  }
}
